/**
 * The wall of roles: the same measurement the numbers above it state, rendered as evidence.
 *
 * Composition, not volume. We lose a contact-count race against Apollo, and a percentage asks the
 * reader for belief where a wall of real titles asks for half a second. `senior` carries seniority
 * by WEIGHT alone — alternating two colours produced a rash.
 */
export type NetworkRole = { label: string; senior: boolean }

const role = (label: string, senior = false): NetworkRole => ({ label, senior })

export const ROLE_ROWS: readonly (readonly NetworkRole[])[] = [
  [
    role('Founder & CEO', true), role('VP Marketing'), role('CTO', true), role('Head of Sales'),
    role('CFO', true), role('Head of Growth'), role('COO', true), role('Director of Product'),
    role('Chief People Officer', true), role('Head of Product'), role('Managing Director', true),
    role('President', true), role('Head of Operations'), role('Chief Revenue Officer', true),
    role('VP Finance'), role('General Counsel', true), role('Head of Talent'), role('CMO', true),
  ],
  [
    role('Country Manager'), role('Managing Partner', true), role('Head of Design'),
    role('Chief Product Officer', true), role('VP People'), role('Board Member', true),
    role('Founder', true), role('Head of Marketing'), role('CIO', true), role('VP Sales'),
    role('Chief of Staff'), role('CEO', true), role('Head of Legal'),
    role('Executive Director', true), role('Head of Engineering'), role('CISO', true),
    role('Head of Finance'), role('Owner', true),
  ],
]

/**
 * NUMBERS ARE MEASURED, NOT ESTIMATED (live research index, 2026-08-23):
 *   511,807  profiles in the searchable index
 *   119,858  carrying founder / C-level / head-of-function titles
 *   244,991  distinct company strings (free text, so an upper bound on real companies)
 *
 * The 700,000+ headline is the platform's own member count, as used elsewhere on this page and in
 * the app; the index number above is smaller and worth reconciling. A percentage was rejected here
 * because it would be a share of the INDEX while the first column quotes the MEMBER count, and the
 * two bases do not match — so the middle column shows the absolute figure. "50,000+ companies" is
 * deliberately conservative against the 244,991 distinct strings.
 *
 * RECHECK QUARTERLY — next due 2026-11-23.
 */
export const NETWORK_STATS = [
  { key: 'professionals', value: '700,000+' },
  { key: 'decisionMakers', value: '119,000+' },
  { key: 'companies', value: '50,000+' },
] as const
